/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiDimension;
(function (ApiDimension) {
    ApiDimension["DIMENSION_NOT_SET"] = "DimensionNotSet";
    ApiDimension["DIMENSION_SESSION_START_BY_DAY"] = "DimensionSessionStartByDay";
    ApiDimension["DIMENSION_LOCATION"] = "DimensionLocation";
    ApiDimension["DIMENSION_BROWSER"] = "DimensionBrowser";
    ApiDimension["DIMENSION_OS"] = "DimensionOS";
    ApiDimension["DIMENSION_DEVICE"] = "DimensionDevice";
    ApiDimension["DIMENSION_CHANNEL"] = "DimensionChannel";
    ApiDimension["DIMENSION_VISITOR_TYPE"] = "DimensionVisitorType";
    ApiDimension["DIMENSION_COUNTRY"] = "DimensionCountry";
    ApiDimension["DIMENSION_REGION"] = "DimensionRegion";
    ApiDimension["DIMENSION_CITY"] = "DimensionCity";
    ApiDimension["DIMENSION_LAT_LONG"] = "DimensionLatLong";
    ApiDimension["DIMENSION_SESSION_AUDIENCE"] = "DimensionSessionAudience";
    ApiDimension["DIMENSION_LEAD_AUDIENCE"] = "DimensionLeadAudience";
    ApiDimension["DIMENSION_SOURCE"] = "DimensionSource";
    ApiDimension["DIMENSION_MEDIUM"] = "DimensionMedium";
    ApiDimension["DIMENSION_CAMPAIGN"] = "DimensionCampaign";
    ApiDimension["DIMENSION_CONTENT"] = "DimensionContent";
    ApiDimension["DIMENSION_TERM"] = "DimensionTerm";
    ApiDimension["DIMENSION_PATH"] = "DimensionPath";
    ApiDimension["DIMENSION_PRODUCT_NAME"] = "DimensionProductName";
    ApiDimension["DIMENSION_PRODUCT_CATEGORY"] = "DimensionProductCategory";
    ApiDimension["DIMENSION_PRODUCT_BRAND"] = "DimensionProductBrand";
    ApiDimension["DIMENSION_JOB_TITLE"] = "DimensionJobTitle";
    ApiDimension["DIMENSION_JOB_CATEGORY"] = "DimensionJobCategory";
    ApiDimension["DIMENSION_PRODUCT"] = "DimensionProduct";
    ApiDimension["DIMENSION_JOB"] = "DimensionJob";
    ApiDimension["DIMENSION_LOCATION_PAGE_TYPE"] = "DimensionLocationPageType";
    ApiDimension["DIMENSION_LANDING_PAGE_PATH"] = "DimensionLandingPagePath";
    ApiDimension["DIMENSION_LANDING_PAGE_LOCATION_TAGGER_VALUE"] = "DimensionLandingPageLocationTaggerValue";
    ApiDimension["DIMENSION_LANDING_PAGE_LOCATION"] = "DimensionLandingPageLocation";
    ApiDimension["DIMENSION_LANDING_PAGE_TYPE"] = "DimensionLandingPageType";
    ApiDimension["DIMENSION_LOCATION_TAGGER_VALUE"] = "DimensionLocationTaggerValue";
    ApiDimension["DIMENSION_LANDING_NEXT_PAGE_PATH"] = "DimensionLandingNextPagePath";
    ApiDimension["DIMENSION_LANDING_NEXT_PAGE_LOCATION_TAGGER_VALUE"] = "DimensionLandingNextPageLocationTaggerValue";
    ApiDimension["DIMENSION_LANDING_NEXT_PAGE_LOCATION"] = "DimensionLandingNextPageLocation";
    ApiDimension["DIMENSION_LANDING_NEXT_PAGE_TYPE"] = "DimensionLandingNextPageType";
    ApiDimension["DIMENSION_SESSION_START_BY_HOUR"] = "DimensionSessionStartByHour";
    ApiDimension["DIMENSION_SESSION_START_BY_WEEK"] = "DimensionSessionStartByWeek";
    ApiDimension["DIMENSION_SESSION_START_BY_MONTH"] = "DimensionSessionStartByMonth";
    ApiDimension["DIMENSION_SESSION_START_BY_WEEKDAY"] = "DimensionSessionStartByWeekday";
    ApiDimension["DIMENSION_MICRO_CONVERSION"] = "DimensionMicroConversion";
    ApiDimension["DIMENSION_MACRO_CONVERSION"] = "DimensionMacroConversion";
    ApiDimension["DIMENSION_CRAWLER"] = "DimensionCrawler";
    ApiDimension["DIMENSION_DAYS_TO_SECOND_VISIT"] = "DimensionDaysToSecondVisit";
    ApiDimension["DIMENSION_LOCATION_TAGGER"] = "DimensionLocationTagger";
    ApiDimension["DIMENSION_SOURCE_BUCKET"] = "DimensionSourceBucket";
    ApiDimension["DIMENSION_SESSION_LANDING_PAGE_LOCATION"] = "DimensionSessionLandingPageLocation";
    ApiDimension["DIMENSION_BROWSER_VERSION"] = "DimensionBrowserVersion";
    ApiDimension["DIMENSION_BROWSER_WITH_VERSION"] = "DimensionBrowserWithVersion";
    ApiDimension["DIMENSION_CHANNEL_MACRO_CONVERSION_JOURNEY"] = "DimensionChannelMacroConversionJourney";
    ApiDimension["DIMENSION_CONVERTING_SESSION_JOURNEY"] = "DimensionConvertingSessionJourney";
    ApiDimension["DIMENSION_VISITS_SINCE_PRIOR_MACRO_CONVERSION"] = "DimensionVisitsSincePriorMacroConversion";
    ApiDimension["DIMENSION_DAYS_SINCE_PRIOR_MACRO_CONVERSION"] = "DimensionDaysSincePriorMacroConversion";
    ApiDimension["DIMENSION_CHANNEL_SALES_JOURNEY"] = "DimensionChannelSalesJourney";
    ApiDimension["DIMENSION_SALES_SESSION_JOURNEY"] = "DimensionSalesSessionJourney";
    ApiDimension["DIMENSION_LANDING_PAGE_LOCATION_TAGGER"] = "DimensionLandingPageLocationTagger";
    ApiDimension["DIMENSION_LANDING_NEXT_PAGE_LOCATION_TAGGER"] = "DimensionLandingNextPageLocationTagger";
    ApiDimension["DIMENSION_SESSION_LANDING_PAGE_TYPE"] = "DimensionSessionLandingPageType";
    ApiDimension["DIMENSION_SESSION_LANDING_PAGE_PATH"] = "DimensionSessionLandingPagePath";
    ApiDimension["DIMENSION_INTERNAL_CAMPAIGN"] = "DimensionInternalCampaign";
    ApiDimension["DIMENSION_INTERNAL_CAMPAIGN_LEAD_STATUS"] = "DimensionInternalCampaignLeadStatus";
    ApiDimension["DIMENSION_INTERNAL_CAMPAIGN_TYPE"] = "DimensionInternalCampaignType";
    ApiDimension["DIMENSION_INTERNAL_AB_CAMPAIGN"] = "DimensionInternalABCampaign";
    ApiDimension["DIMENSION_DOMAIN"] = "DimensionDomain";
    ApiDimension["DIMENSION_PERSONALISATION"] = "DimensionPersonalisation";
    ApiDimension["DIMENSION_VISITS_TO_FIRST_MACRO_CONVERSION"] = "DimensionVisitsToFirstMacroConversion";
    ApiDimension["DIMENSION_DAYS_TO_FIRST_MACRO_CONVERSION"] = "DimensionDaysToFirstMacroConversion";
    ApiDimension["DIMENSION_IS_RETURNING_CUSTOMER"] = "DimensionIsReturningCustomer";
    ApiDimension["DIMENSION_SESSION_ID"] = "DimensionSessionID";
    ApiDimension["DIMENSION_SESSION_START_DATE"] = "DimensionSessionStartDate";
    ApiDimension["DIMENSION_TRANSACTION_ID"] = "DimensionTransactionId";
    ApiDimension["DIMENSION_QUERY_STRING_PARAM"] = "DimensionQueryStringParam";
    ApiDimension["DIMENSION_QUERY_STRING_VALUE"] = "DimensionQueryStringValue";
    ApiDimension["DIMENSION_QUERY_STRING_PAIR"] = "DimensionQueryStringPair";
    ApiDimension["DIMENSION_QUERY_STRING"] = "DimensionQueryString";
    ApiDimension["DIMENSION_FULL_URL"] = "DimensionFullURL";
    ApiDimension["DIMENSION_LANDING_PAGE_QUERY_STRING_PARAM"] = "DimensionLandingPageQueryStringParam";
    ApiDimension["DIMENSION_LANDING_PAGE_QUERY_STRING_VALUE"] = "DimensionLandingPageQueryStringValue";
    ApiDimension["DIMENSION_LANDING_PAGE_QUERY_STRING_PAIR"] = "DimensionLandingPageQueryStringPair";
    ApiDimension["DIMENSION_LANDING_PAGE_QUERY_STRING"] = "DimensionLandingPageQueryString";
    ApiDimension["DIMENSION_LANDING_PAGE_FULL_URL"] = "DimensionLandingPageFullURL";
    ApiDimension["DIMENSION_REFERRER"] = "DimensionReferrer";
    ApiDimension["DIMENSION_REFERRER_PATH"] = "DimensionReferrerPath";
    ApiDimension["DIMENSION_REFERRER_DOMAIN"] = "DimensionReferrerDomain";
    ApiDimension["DIMENSION_MATCH_TYPE"] = "DimensionMatchType";
    ApiDimension["DIMENSION_TERM_WITH_MATCH_TYPE"] = "DimensionTermWithMatchType";
    ApiDimension["DIMENSION_PAGE_STATUS_CODE"] = "DimensionPageStatusCode";
    ApiDimension["DIMENSION_SESSION_START_BY_HOUR_OF_DAY"] = "DimensionSessionStartByHourOfDay";
    ApiDimension["DIMENSION_SESSION_START_BY_DAY_OF_MONTH"] = "DimensionSessionStartByDayOfMonth";
    ApiDimension["DIMENSION_SESSION_START_BY_DAY_OF_YEAR"] = "DimensionSessionStartByDayOfYear";
    ApiDimension["DIMENSION_NEXT_UNIQUE_PAGE"] = "DimensionNextUniquePage";
    ApiDimension["DIMENSION_NEXT_UNIQUE_LOCATIONS"] = "DimensionNextUniqueLocations";
    ApiDimension["DIMENSION_VELOCITY_STATUS"] = "DimensionVelocityStatus";
    ApiDimension["DIMENSION_SOURCE_CATEGORY"] = "DimensionSourceCategory";
    ApiDimension["DIMENSION_FIRST_SALE_DATE"] = "DimensionFirstSaleDate";
    ApiDimension["DIMENSION_FIRST_SALE_MONTH"] = "DimensionFirstSaleMonth";
    ApiDimension["DIMENSION_FIRST_PURCHASED_PRODUCT_NAME"] = "DimensionFirstPurchasedProductName";
    ApiDimension["DIMENSION_SALE_BUCKET_DATE"] = "DimensionSaleBucketDate";
    ApiDimension["DIMENSION_CONVERSION_BUCKET_DATE"] = "DimensionConversionBucketDate";
    ApiDimension["DIMENSION_EXIT_PAGE_LOCATION"] = "DimensionExitPageLocation";
    ApiDimension["DIMENSION_EXIT_PAGE_PATH"] = "DimensionExitPagePath";
    ApiDimension["DIMENSION_IS_LANDING_PAGE"] = "DimensionIsLandingPage";
    ApiDimension["DIMENSION_LEAD_ID"] = "DimensionLeadId";
    ApiDimension["DIMENSION_TRAFFIC_TYPE"] = "DimensionTrafficType";
    ApiDimension["DIMENSION_INTERNAL_SPLIT_CAMPAIGN"] = "DimensionInternalSplitCampaign";
    ApiDimension["DIMENSION_INTERNAL_SPLIT_CAMPAIGN_URL_NAME"] = "DimensionInternalSplitCampaignUrlName";
    ApiDimension["DIMENSION_INTERNAL_SPLIT_CAMPAIGN_URL_URL"] = "DimensionInternalSplitCampaignUrlUrl";
    ApiDimension["DIMENSION_INTERNAL_SPLIT_CAMPAIGN_URL_NAME_AND_URL"] = "DimensionInternalSplitCampaignUrlNameAndUrl";
    ApiDimension["DIMENSION_FUNNEL_STAGE"] = "DimensionFunnelStage";
    ApiDimension["DIMENSION_FUNNEL_START_DATE"] = "DimensionFunnelStartDate";
    ApiDimension["DIMENSION_SALE_ORDER_STATUS"] = "DimensionSaleOrderStatus";
    ApiDimension["DIMENSION_DAYS_TO_SECOND_PURCHASE"] = "DimensionDaysToSecondPurchase";
    ApiDimension["DIMENSION_RFM_SEGMENT"] = "DimensionRfmSegment";
    ApiDimension["DIMENSION_EMAIL_ADDRESS"] = "DimensionEmailAddress";
    ApiDimension["DIMENSION_NAME"] = "DimensionName";
    ApiDimension["DIMENSION_LEAD_KEY"] = "DimensionLeadKey";
    ApiDimension["DIMENSION_SESSION_LOAD_EXPERIENCE"] = "DimensionSessionLoadExperience";
    ApiDimension["DIMENSION_PAGE_LOAD_EXPERIENCE"] = "DimensionPageLoadExperience";
    ApiDimension["DIMENSION_WEEKS_TO_SECOND_PURCHASE"] = "DimensionWeeksToSecondPurchase";
    ApiDimension["DIMENSION_DAYS_TO_SECOND_PURCHASE_BUCKET"] = "DimensionDaysToSecondPurchaseBucket";
    ApiDimension["DIMENSION_CUSTOMER_TYPE"] = "DimensionCustomerType";
    ApiDimension["DIMENSION_EXTERNAL_AD_ID"] = "DimensionExternalAdId";
    ApiDimension["DIMENSION_EXTERNAL_AD_NAME"] = "DimensionExternalAdName";
})(ApiDimension || (ApiDimension = {}));
export function ApiDimensionFromJSON(json) {
    return ApiDimensionFromJSONTyped(json, false);
}
export function ApiDimensionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiDimensionToJSON(value) {
    return value;
}
